export enum CalendarTypeEnum {
  google = 0,
  yahoo = 1,
  iCalendar = 2,
  outlook = 3,
  outlookLive = 4,
}
